import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import CustomPanelTab from "../../common/CustomPanelTab";

import Notification from "../Notification";
import InAppNotification from "../InAppNotification";

function PanelNotification() {
    const { tab } = useParams();
    const [activeTab, setActiveTab] = useState(null);
    const tabs = [
        { "name": "Push Notification", "path": "/push-notification" },
        { "name": "In-App Notification", "path": "/in-app-notification" },
    ];

    useEffect(() => {
        const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_ADMIN_URL : process.env.REACT_APP_ADMIN_URL_DEV);
        activeTab?.path && window.history.pushState({}, "", `${link}notifications-panel${activeTab?.path}`);
    }, [activeTab]);

    return (
        <div id="notifications-panel" className="custom-panel">
            <div className="panel-header">
                <h4>Notifications</h4>
            </div>
            <CustomPanelTab tabs={tabs}
                defaultTab={tabs?.find(t => t?.path == ('/' + tab))}
                setActiveTab={setActiveTab} />

            <div className="panel-content">
                {
                    activeTab?.name == "Push Notification" && <Notification />
                }
                {
                    activeTab?.name == "In-App Notification" && <InAppNotification />
                }

            </div>
        </div>
    );
}

export default PanelNotification;